import styled from "@emotion/styled";
import { Trans } from "@lingui/react/macro";
import { Upsell as LibraryUpsell } from "@togglhire/candidate-components";
import purpleLogo from "./assets/togglhire-purple.svg";

interface UpsellProps {
  logoSize?: string;
}

export function Upsell({ logoSize = "auto" }: UpsellProps) {
  return (
    <StyledLibraryUpsell linkUrl="https://togglhire.com">
      <Trans comment="Powered by (Toggl Hire)">Powered by</Trans>
      &nbsp;&nbsp;
      <StyledLibraryUpsellLogo
        src={purpleLogo.src}
        size={logoSize}
        alt="Toggl Hire"
      />
    </StyledLibraryUpsell>
  );
}

const StyledLibraryUpsell = styled(LibraryUpsell)`
  color: ${(props) => props.theme.colors.purple[60]};
`;

const StyledLibraryUpsellLogo = styled(LibraryUpsell.Logo)<{
  size: string;
}>`
  height: ${(props) => props.size};
`;
